export const OVERVIEWS_ROUTE_PREFIX = "/overviews";

export const OVERVIEWS_ROUTE_PATHS = {
  businessCoefficients: { path: "business-coefficients", to: `${OVERVIEWS_ROUTE_PREFIX}/business-coefficients` },
  investCombinations: { path: "invest-combinations", to: `${OVERVIEWS_ROUTE_PREFIX}/invest-combinations` },
};
